// project import
// import support from './support
import dashboard from './dashboard';
import managements from './managements';
import notifications from './notifications';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    managements,
    notifications
    // support
  ]
};

export default menuItems;
